import { IconButton, Snackbar, SnackbarContent } from '@mui/material';
import React, { useContext } from 'react';
import { AiOutlineCheckCircle, AiOutlineSend } from 'react-icons/ai';
import { FaGithub, FaLinkedinIn } from 'react-icons/fa';
import { IoClose } from 'react-icons/io5';
import { ThemeContext } from '../../../contexts/theme-context';
import { contactsData } from '../../../data/contactsData';
import './contact.css';
import { useTranslation } from '../../../TranslationContext';

const ContactUI = ({ open, success, errMsg, handleClose, classes, handleContactForm, name, setName, form, email, setEmail, message, setMessage, turnstileWidget }) => {
  const { theme } = useContext(ThemeContext);
  const { translate } = useTranslation();

  return (
    <div
      className='contacts'
      id='contacts'
      style={{ backgroundColor: theme.secondary }}
    >
  <div class="horizontal-rule"></div>
      <div className='contacts--container'>
        <h1 style={{ color: theme.primary }}>Contact</h1>
        <div className='contacts-body'>
          <div className='contacts-form'>
            <form ref={form} onSubmit={handleContactForm}>
  <div className='input-container'>
    <label id='Name' className={classes.label}>
      {translate('name', 'contacts')}
    </label>
    <input
      placeholder={translate('placeholder', 'contacts')}
      value={name}
      onChange={(e) => setName(e.target.value)}
      type='text'
      name='from_name'
      className={`form-input ${classes.input}`}
    />
  </div>
  <div className='input-container'>
    <label
      id='E-mail'
      className={classes.label}
    >
      E-mail
    </label>
    <input
      placeholder='abcde@email.com '
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      type='email'
      name='user_email'
      className={`form-input ${classes.input}`}
    />
  </div>
  <div className='input-container'>
    <label
      id='Message'
      className={classes.label}
    >
      Message
    </label>
    <textarea
      placeholder={translate('message', 'contacts')}
      value={message}
      onChange={(e) => setMessage(e.target.value)}
      type='text'
      name='message'
      className={`form-message ${classes.message}`}
    />
  </div>

  <div className='submit-btn'>
    <button
      type='submit'
      className={classes.submitBtn}
    >
      <p>{!success ? translate('sendBtn', 'contacts') : translate('sendBtn', 'contacts')}</p>

      <div className='submit-icon'>
        <AiOutlineSend
          className='send-icon'
          style={{
            animation: !success ? 'initial' : 'fly 0.8s linear both',
            position: success ? 'absolute' : 'initial',
          }}
        />
        <AiOutlineCheckCircle
          className='success-icon'
          style={{
            display: !success ? 'none' : 'inline-flex',
            opacity: !success ? '0' : '1',
          }}
        />
      </div>
    </button>
  </div>
  {turnstileWidget}
</form>
            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              open={open}
              autoHideDuration={4000}
              onClose={handleClose}
            >
              <SnackbarContent
                action={
                  <React.Fragment>
                    <IconButton
                      size='small'
                      aria-label='close'
                      color='inherit'
                      onClick={handleClose}
                    >
                      <IoClose fontSize='small' />
                    </IconButton>
                  </React.Fragment>
                }
                style={{
                  backgroundColor: theme.primary,
                  color: theme.secondary,
                  fontFamily: 'var(--primaryFont)',
                }}
                message={errMsg}
              />
            </Snackbar>
          </div>

          <div className='contacts-details'>

            <div className='socialmedia-icons'>
              {contactsData.github && (
                <a
                  href={contactsData.github}
                  target='_blank'
                  rel='noreferrer'
                  className={classes.socialIcon}
                >
                  <FaGithub aria-label='GitHub' />
                </a>
              )}
              {contactsData.linkedIn && (
                <a
                  href={contactsData.linkedIn}
                  target='_blank'
                  rel='noreferrer'
                  className={classes.socialIcon}
                >
               <FaLinkedinIn aria-label='LinkedIn' style={{ fill: '#0777b8' }} />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
      <img
        src={theme.contactsimg}
        alt='contacts'
        className='contacts--img'
      />
        <div className='contacts--footer'>
        <p style={{ color: theme.primary }}>© 2026 Dev-Digital Marketing</p>
          </div> 
    </div>
  );
};

export default ContactUI;
